import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Pagination, Card, message } from "antd";
import Grid from '../../atoms/Grid';

import { exportAuditReportService } from './service';
import { dateByformat } from "../../../utils/dateHelper";
import { currencyFormat } from "../../../utils/helper";
import {conertToLocalTimeZone} from './utilis'
import { Loader } from '../../atoms/Loader';
import moment from 'moment';

const ExportAuditReportComponent = ({
    setExportReport,
    exportReport,
    startDate,
    endDate,
    setTotalRecord,
    totalRecord,
    searchText,
    searchingBy,
    orgId,
    isLoginReport
}) => {

    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [exportLogList, setExportLogList] = useState([]);

    const gridProps = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 200,
    };

    const pdcCol = useMemo(() => {


        return [

            {
                headerName: "Organization",
                field: "organization",
            },
            {
                headerName: "Portal",
                field: "portal",
            },

            {
                headerName: "User",
                field: "userName",
            },
            {
                headerName: "Screen",
                field: "screen",
                minWidth: 240,
                hide: isLoginReport
            },
            {
                headerName: "No. of records",
                field: "recordCount",
                minWidth: 200,
                hide: isLoginReport
            },
            // exportStatus	
            {
                headerName: "Export Status",
                field: "exportStatus",
                minWidth: 200,
                hide: isLoginReport
            },
            {
                headerName: "Login Timestamp (GMT +04:00)",
                field: isLoginReport ? "loginTime" : "exportTime",
                minWidth: 300,
                cellRendererFramework: ({ data }) => {
                   
                    return (
                        isLoginReport ? 
                       data?.loginTime
                        :
                        data?.exportTime
                       
                    )
                },
            },

            {
                headerName: "IP address",
                field: "ipAddress",
               
            },

        ];
    }, [exportLogList]);

    const handlePagination = (pg) => {
        setPage(pg);
    };

    const getExportLogAuditReportData = async () => {

        !exportReport && setIsLoading(true);

        try {

            let payload = {
                "organization": orgId && orgId !== 'all orgnizations' ? orgId : '',
                "startDate": startDate ? startDate : "",
                "endDate": endDate ? endDate : "",
                "portal": "",
                "userName": "",
                "page": page + 1,
                "limit": 50,
                "exportData": exportReport ? exportReport : false,
                "totalCount": exportReport ? totalRecord : "",
            }
            if (searchingBy === "portal" && searchText) {
                payload["portal"] = searchText;
            } else if (searchingBy === "userName" && searchText) {
                payload["userName"] = searchText;
            }

            const data = await exportAuditReportService(payload, isLoginReport);

            if (data?.code === 201 && data?.result?.data) {
                setTotalRecord(data?.result?.totalCount);
                setExportLogList(data?.result?.data);
                setExportReport(false)
                setIsLoading(false);
            } else if (data?.code === 201 && !data?.result?.data) {
                setExportReport(false);
                setIsLoading(false);
                message.success(data?.result);
            } else {
                setIsLoading(false);
            }

        } catch (error) {
            setExportReport(false);
            console.log(error)
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getExportLogAuditReportData();
    }, [searchText, orgId, page, exportReport, startDate]);

    return (
        <>
            {

                isLoading ?
                    <Loader height={60} />
                    :

                    <>

                        <Col span={24}>
                            <Pagination
                                className="ag-property-text-pagination"
                                total={totalRecord}
                                showSizeChanger={false}
                                showTotal={(total, range) =>
                                    `Showing ${range[0]}-${range[1]}-${total} payments`
                                }
                                defaultPageSize={50}
                                defaultCurrent={1}
                                current={page + 1}
                                onChange={(e) => handlePagination(e - 1)}
                            />
                        </Col>

                        <Col span={24}>
                            <Row gutter={[24, 24]} justify="end">
                                <Col span={24}>
                                    <Card
                                        bordered={false}
                                        className="ag-nospace-body"
                                    >
                                        <Grid
                                            data={exportLogList}
                                            columns={pdcCol}
                                            pagination={false}
                                            defaultSettings={gridProps}
                                            noRowlabel="data"
                                            fullPage={true}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </>
            }
        </>
    )
}

export default React.memo(ExportAuditReportComponent);